export const environment = {
    production: false,
    preproduction: false,
    host: 'https://apiblinkdev.hubplatforms.com',
    logoutURL: '/mygate/login',
    API_CLIENT: '2Pwhuy2Ka2HURwfwmVf598mjqV23YXbz',
    prefix: '/tuwaiq',
    ENCRYPTION_PUBLIC_KEY:
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0Hdu+pDl1u+dtxPtUTTL41Sde6zgnbusFLS+tZHZg0lw+ywk8XCzaD06X1cnHYsnU6JQUG4F+YUinn/Yo/crODir+2xoIvX6BMJR+Pk5jnni7lhGBfeLjiVxhlHUShpHzsVC7wfEjNn19xGTEv6MqwkkmUDYaKyOYNct7laLYRXyzSFla5Vpe4tl+Uy92QsxrYmqx5UNKkSulUbqlw9AD950erL3XS85rcrvNlwrC0a2rl3cE4xWr2Q0YCFu2L1VE9TTCZTMfyXu6LupjUedQaI113SEhcZXT8+ia5Ut5gwBsKau2D0OEUvzSZ3EK66fRzmsZ+iWA1KOmkNikU3jVwIDAQAB',
    backend: 'https://apiblinkdev.hubplatforms.com',
    mygateprod: false,
    domainWildCard: '.hubplatforms.com',
    socketUrl: 'wss://apiblinkdev.hubplatforms.com/tuwaiq/ws',
    alphaUsers: []
};
